import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './matter-checklist.actions';
import { BusinessChecklistVM, ChecklistItem } from '@models/checklist';

@Injectable({
	providedIn: 'root',
})
export class MatterChecklistsDispatch {
	@Dispatch()
	Get = (id: string): actions.Get => new actions.Get(id);

	@Dispatch()
	GetAll = (): actions.GetAll => new actions.GetAll();

	@Dispatch()
	CreateAll = (template: BusinessChecklistVM): actions.CreateAll =>
		new actions.CreateAll(template);

	@Dispatch()
	CreateItem = (item: ChecklistItem): actions.CreateItem =>
		new actions.CreateItem(item);

	@Dispatch()
	RemoveAll = (): actions.RemoveAll => new actions.RemoveAll();

	@Dispatch()
	Remove = (id: string): actions.Remove => new actions.Remove(id);

	@Dispatch()
	Update = (item: ChecklistItem): actions.Update => new actions.Update(item);

	@Dispatch()
	toggleTask = (id: string, complete: boolean): actions.ToggleTask =>
		new actions.ToggleTask({ id, complete });

	@Dispatch()
	toggleAllTasks = (complete: boolean): actions.ToggleAllTasks =>
		new actions.ToggleAllTasks(complete);

	@Dispatch()
	updateProgress = (): actions.UpdateProgress => new actions.UpdateProgress();

	@Dispatch()
	updateStageOpenedState = (payload: {
		id: string;
		opened: boolean;
	}): actions.UpdateStageOpenedState =>
		new actions.UpdateStageOpenedState(payload);
}
